import React from 'react';
interface ElephantMascotProps {
  size?: 'sm' | 'md' | 'lg';
  message?: React.ReactNode;
  direction?: 'left' | 'right';
  className?: string;
  noBg?: boolean;
}
export function ElephantMascot({
  size = 'md',
  message,
  direction = 'right',
  className = '',
  noBg = false
}: ElephantMascotProps) {
  const sizeMap = {
    sm: {
      container: 'w-24 h-24',
      eye: {
        w: 14,
        h: 15
      },
      pupil: 4,
      shine: 2,
      leftEye: {
        top: '28%',
        left: '36%'
      },
      rightEye: {
        top: '26%',
        left: '53%'
      },
      bubbleText: 'text-sm',
      bubbleP: 'p-3',
      minW: 'min-w-[160px]'
    },
    md: {
      container: 'w-36 h-36',
      eye: {
        w: 20,
        h: 22
      },
      pupil: 5,
      shine: 2.5,
      leftEye: {
        top: '28%',
        left: '36%'
      },
      rightEye: {
        top: '26%',
        left: '53%'
      },
      bubbleText: 'text-base',
      bubbleP: 'p-4',
      minW: 'min-w-[200px]'
    },
    lg: {
      container: 'w-52 h-52',
      eye: {
        w: 28,
        h: 30
      },
      pupil: 7,
      shine: 3.5,
      leftEye: {
        top: '28%',
        left: '36%'
      },
      rightEye: {
        top: '26%',
        left: '53%'
      },
      bubbleText: 'text-lg',
      bubbleP: 'p-5',
      minW: 'min-w-[240px]'
    }
  };
  const s = sizeMap[size];
  const isRight = direction === 'right';
  return <div className={`relative inline-flex items-end ${className}`} data-id="element-143" data-mp="1jcq7e8xm6ex5">
      {/* Cloud Speech Bubble — whisper animation */}
      {message && <div className={`absolute bottom-[70%] ${isRight ? 'left-[50%]' : 'right-[50%]'} z-20 animate-whisper-in`} style={{
      width: '252px',
      height: '162px'
    }} data-id="element-144" data-mp="1t8jugm8ylqt6">
          {/* Cloud bubble — using uploaded PNG */}
          <div className="relative animate-whisper-float w-full h-full" data-id="element-145" data-mp="39nbb61wqt9mn">
            <img src="https://cdn.magicpatterns.com/uploads/r4DUCGCtxEPRWd51y9XGP6/thought-bubble.png" alt="" className="absolute inset-0 w-full h-full object-contain" draggable={false} data-id="element-146" data-mp="39li4imm4qpen" />
            <div className="relative flex items-center justify-center w-full h-[70%] px-6" data-id="element-147" data-mp="1im1juwotgoiw">
              <p className={`font-bold ${s.bubbleText} leading-tight text-white text-center`} data-id="element-148" data-mp="1ejn44lgg24vu">
                {message}
              </p>
            </div>
          </div>
        </div>}

      {/* Elephant with sparkles */}
      <div className={`${s.container} relative z-10 ${!isRight ? 'scale-x-[-1]' : ''}`} data-id="element-149" data-mp="lteiukqm34d1">
        {/* Floating Sparkles, Hearts & Kisses */}
        <svg className="absolute -top-2 -left-2 w-[calc(100%+16px)] h-[calc(100%+16px)] pointer-events-none z-20" viewBox="0 0 100 100" data-id="element-150" data-mp="uv4hobmtp5ku">
          {/* Sparkle ✨ — top right */}
          <g className="animate-sparkle-1" data-id="element-151" data-mp="34857c4od2y3">
            <path d="M 78 12 L 80 8 L 82 12 L 86 14 L 82 16 L 80 20 L 78 16 L 74 14 Z" fill="#FFFC00" stroke="#1A1A1A" strokeWidth="0.8" data-id="element-152" data-mp="336r0ysd40c5" />
          </g>
          {/* Heart ❤️ — top left */}
          <g className="animate-sparkle-2" data-id="element-153" data-mp="3f9lvn1ui39zk">
            <path d="M 18 20 C 18 17, 22 15, 22 18 C 22 15, 26 17, 26 20 C 26 24, 22 27, 22 27 C 22 27, 18 24, 18 20 Z" fill="#FF6B8A" stroke="#1A1A1A" strokeWidth="0.8" data-id="element-154" data-mp="3k7dpi1eph66e" />
          </g>
          {/* Kiss 💋 — right side */}
          <g className="animate-sparkle-3" data-id="element-155" data-mp="goayt1lze4ny">
            <path d="M 88 44 C 86 42, 86 40, 88 40 C 90 40, 90 42, 90 42 C 90 42, 92 40, 94 40 C 96 40, 96 42, 94 44 C 92 46, 91 48, 91 48 C 91 48, 90 46, 88 44 Z" fill="#FF4D6D" stroke="#1A1A1A" strokeWidth="0.6" data-id="element-156" data-mp="1scwf1lgs43a" />
          </g>
          {/* Heart ❤️ — bottom left */}
          <g className="animate-sparkle-4" data-id="element-157" data-mp="2rglwfcsxsxna">
            <path d="M 6 66 C 6 63, 10 61, 10 64 C 10 61, 14 63, 14 66 C 14 70, 10 73, 10 73 C 10 73, 6 70, 6 66 Z" fill="#FF6B8A" stroke="#1A1A1A" strokeWidth="0.8" data-id="element-158" data-mp="37qd07kfjmrzu" />
          </g>
          {/* Sparkle ✨ — bottom right */}
          <g className="animate-sparkle-2" data-id="element-159" data-mp="2t1gsxplb9j0a">
            <path d="M 85 72 L 86.5 69 L 88 72 L 91 73.5 L 88 75 L 86.5 78 L 85 75 L 82 73.5 Z" fill="#FFFC00" stroke="#1A1A1A" strokeWidth="0.8" data-id="element-160" data-mp="2t2i5jyhz6dk4" />
          </g>
          {/* Small heart — top center */}
          <g className="animate-sparkle-3" data-id="element-161" data-mp="3gpq6y5ca92gv">
            <path d="M 55 4 C 55 2, 57 1, 57 3 C 57 1, 59 2, 59 4 C 59 6, 57 8, 57 8 C 57 8, 55 6, 55 4 Z" fill="#FF6B8A" stroke="#1A1A1A" strokeWidth="0.5" data-id="element-162" data-mp="3gsm61wzv9x6w" />
          </g>
          {/* Small sparkle — left */}
          <g className="animate-sparkle-1" data-id="element-163" data-mp="20aq4076hl1zj">
            <path d="M 4 38 L 5 36 L 6 38 L 8 39 L 6 40 L 5 42 L 4 40 L 2 39 Z" fill="#FFFC00" stroke="#1A1A1A" strokeWidth="0.5" data-id="element-164" data-mp="fuijfn07mde6" />
          </g>
          {/* Small kiss — top */}
          <g className="animate-sparkle-4" data-id="element-165" data-mp="pqty2jn9vfbs">
            <path d="M 38 6 C 37 5, 37 4, 38 4 C 39 4, 39 5, 39 5 C 39 5, 40 4, 41 4 C 42 4, 42 5, 41 6 C 40 7, 39.5 8, 39.5 8 C 39.5 8, 39 7, 38 6 Z" fill="#FF4D6D" stroke="#1A1A1A" strokeWidth="0.4" data-id="element-166" data-mp="uj4ydnlxd34v" />
          </g>
        </svg>

        {/* Elephant image */}
        <div className="w-full h-full rounded-full overflow-hidden bg-[#FFFC00]" data-id="element-167" data-mp="18ims8he2v6l3">
          <img src="https://cdn.magicpatterns.com/uploads/9x3X3kwbGvw84B5w2gJ2K5/73dba3023d9e2ae68858cb94620f0e25.jpg" alt="Kraya elephant mascot" className="w-full h-full object-contain mix-blend-multiply" draggable={false} data-id="element-168" data-mp="1diiw8gmryy0n" />
        </div>

        {/* Left Eye Overlay */}
        <div className="absolute overflow-hidden flex items-center justify-center" style={{
        top: s.leftEye.top,
        left: s.leftEye.left,
        width: s.eye.w,
        height: s.eye.h
      }} data-id="element-169" data-mp="379fvnnk0qyr7">
          <svg viewBox="0 0 24 26" className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-170" data-mp="3c80xtsitzsia">
            <ellipse cx="12" cy="13" rx="11" ry="12" fill="white" stroke="#8B7B6B" strokeWidth="1.5" data-id="element-171" data-mp="3q67l6eq5ma3p" />
            <circle cx="13" cy="14" r={s.pupil} fill="#3D2B1F" className="animate-look" data-id="element-172" data-mp="3r64b3nxbkgv" />
            <circle cx="10" cy="10" r={s.shine} fill="white" data-id="element-173" data-mp="dr6r4zl04ipt" />
          </svg>
        </div>

        {/* Right Eye Overlay */}
        <div className="absolute overflow-hidden flex items-center justify-center" style={{
        top: s.rightEye.top,
        left: s.rightEye.left,
        width: s.eye.w,
        height: s.eye.h
      }} data-id="element-174" data-mp="8svigs6g0e96">
          <svg viewBox="0 0 24 26" className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-175" data-mp="iffv8m9710gw">
            <ellipse cx="12" cy="13" rx="11" ry="12" fill="white" stroke="#8B7B6B" strokeWidth="1.5" data-id="element-176" data-mp="nfu6sea06sjo" />
            <circle cx="13" cy="14" r={s.pupil} fill="#3D2B1F" className="animate-look" data-id="element-177" data-mp="dheguempppbr" />
            <circle cx="10" cy="10" r={s.shine} fill="white" data-id="element-178" data-mp="4nrpd0pjf88d" />
          </svg>
        </div>
      </div>

      <style data-id="element-179" data-mp="3lw55ai7zisbb">{`
        @keyframes look {
          0%, 100% { transform: translate(0, 0); }
          15% { transform: translate(2px, -1px); }
          30% { transform: translate(2px, 2px); }
          50% { transform: translate(-2px, 1px); }
          70% { transform: translate(-1px, -2px); }
          85% { transform: translate(1px, 0); }
        }
        .animate-look {
          animation: look 5s infinite ease-in-out;
        }
        @keyframes sparkle1 {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.3; transform: scale(0.6); }
        }
        @keyframes sparkle2 {
          0%, 100% { opacity: 0.4; transform: scale(0.7); }
          50% { opacity: 1; transform: scale(1.1); }
        }
        @keyframes sparkle3 {
          0%, 100% { opacity: 0.8; transform: scale(0.9); }
          33% { opacity: 0.2; transform: scale(0.5); }
          66% { opacity: 1; transform: scale(1.05); }
        }
        @keyframes sparkle4 {
          0%, 100% { opacity: 0.5; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1.1); }
          80% { opacity: 0.3; transform: scale(0.6); }
        }
        .animate-sparkle-1 { animation: sparkle1 2.5s infinite ease-in-out; transform-origin: center; }
        .animate-sparkle-2 { animation: sparkle2 3s infinite ease-in-out; transform-origin: center; }
        .animate-sparkle-3 { animation: sparkle3 2.8s infinite ease-in-out; transform-origin: center; }
        .animate-sparkle-4 { animation: sparkle4 3.2s infinite ease-in-out; transform-origin: center; }
        @keyframes whisperIn {
          0% { opacity: 0; transform: scale(0.3) translateY(10px); }
          60% { opacity: 1; transform: scale(1.05) translateY(-2px); }
          80% { transform: scale(0.98) translateY(1px); }
          100% { opacity: 1; transform: scale(1) translateY(0); }
        }
        .animate-whisper-in {
          animation: whisperIn 0.8s ease-out forwards;
        }
        @keyframes whisperFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
        .animate-whisper-float {
          animation: whisperFloat 3s ease-in-out infinite;
        }
      `}</style>
    </div>;
}